// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import BusComponent from '../BusComponent';
import Tooltip from '../Tooltip';
import Mixpanel, { MIXPANEL_EVENTS, MIXPANEL_LOCATIONS } from '../../helpers/Mixpanel';
/**
 * @typedef Props
 * @property {string} mapInstanceId
 * @property {Array.<import('../../types').FeaturedSurveyReport | import('../../types').FeaturedOlapReport>} reports
 * @property {boolean} isUserStarterTier
 * @property {import('react-intl').intlShape} intl
 *
 * @extends {BusComponent<Props>}
 */
class LocationAnalysisReports extends BusComponent {
    constructor(props, context) {
        super(props, context);
    }

    onDownloadReport = report => {
        this.emit('DOWNLOAD_REPORT_REQUEST', {
            report: report,
            mapInstanceId: this.props.mapInstanceId,
        });
        Mixpanel.emitUserEvent(MIXPANEL_EVENTS.CREATE_REPORT, {
            Location: MIXPANEL_LOCATIONS.accordion,
            'Report Name': report.name,
        });
    };

    downloadBtn = report => {
        const { isUserStarterTier } = this.props;
        const isDisabled = isUserStarterTier && report.disabledForStarterTier;

        return (
            <div className="report-popup__download-btn" key={report.name}>
                <button
                    onClick={() => this.onDownloadReport(report)}
                    disabled={isDisabled}
                    className={isDisabled ? 'disabled' : ''}
                >
                    {report.name}
                    <i className="material-symbols">download</i>
                </button>
            </div>
        );
    };

    render() {
        const { reports, isUserStarterTier } = this.props;

        return (
            <div>
                {reports.map((report, idx) => (
                    <div className="report-popup__download-btn" key={report.name}>
                        {isUserStarterTier && report.disabledForStarterTier ? (
                            <Tooltip
                                placement="bottom"
                                mouseEnterDelay={0.5}
                                mouseLeaveDelay={0}
                                overlay={this.props.intl.formatMessage({
                                    id: 'dataBrowser.upgradeToProForAccess',
                                })}
                            >
                                {this.downloadBtn(report)}
                            </Tooltip>
                        ) : (
                            this.downloadBtn(report)
                        )}
                        {idx < reports.length - 1 && <div className="report-popup__divider" />}
                    </div>
                ))}
            </div>
        );
    }
}

LocationAnalysisReports.propTypes = {
    mapInstanceId: PropTypes.string.isRequired,
    reports: PropTypes.array.isRequired,
    isUserStarterTier: PropTypes.bool.isRequired,
    intl: PropTypes.object.isRequired,
};

export default injectIntl(LocationAnalysisReports);
